
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about_45andyPMW1AEGa1yMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/about-andy.vue?macro=true";
import { default as andy_45guitar_45appeVPyeD3MK1Meta } from "/codebuild/output/src3294679881/src/nuxt/pages/andy-guitar-app.vue?macro=true";
import { default as brand_45guidelinesTRMOdmBX9lMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/brand-guidelines.vue?macro=true";
import { default as cookies8fLhQgx6YJMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/cookies.vue?macro=true";
import { default as _91courseSlug_93TxPXmfUcTbMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/courses/[courseSlug].vue?macro=true";
import { default as indexScmAkNI7QSMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/courses/index.vue?macro=true";
import { default as donationsfJFJMafGO5Meta } from "/codebuild/output/src3294679881/src/nuxt/pages/donations.vue?macro=true";
import { default as eventsPXrdwy1NmRMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/events.vue?macro=true";
import { default as featuresaSvzMh44uOMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/features.vue?macro=true";
import { default as free_45christmas_45mini_45songbookyvNciZuNDQMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/free-christmas-mini-songbook.vue?macro=true";
import { default as free_45resourcesYJjhoceUSNMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/free-resources.vue?macro=true";
import { default as _91categorySlug_93t5gHUsP53DMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/helpdesk/[categorySlug].vue?macro=true";
import { default as indexQSATp0yktgMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/helpdesk/index.vue?macro=true";
import { default as indexsz5WUC0rIWMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/index.vue?macro=true";
import { default as _91streamSlug_93lzpgxDhA2IMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/live/[streamSlug].vue?macro=true";
import { default as indexh5CFMqMc2wMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/live/index.vue?macro=true";
import { default as indexrPqeJe0Xu2Meta } from "/codebuild/output/src3294679881/src/nuxt/pages/login-code/index.vue?macro=true";
import { default as _91passcode_93aKkVQuk8RZMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/login/index/[passcode].vue?macro=true";
import { default as indexLGxS2sNbX0Meta } from "/codebuild/output/src3294679881/src/nuxt/pages/login/index.vue?macro=true";
import { default as editJKPHKuCfCCMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/me/edit.vue?macro=true";
import { default as index93NXjJjirnMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/me/index.vue?macro=true";
import { default as notificationsnl87s8Vgt6Meta } from "/codebuild/output/src3294679881/src/nuxt/pages/me/notifications.vue?macro=true";
import { default as canceljcGH25SdICMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/me/subscriptions/[idSubscription]/cancel.vue?macro=true";
import { default as indexp1NO5mL4DZMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/me/subscriptions/[idSubscription]/index.vue?macro=true";
import { default as membershipM8UFtU4K4mMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/membership.vue?macro=true";
import { default as _91token_93rPhBLGgGGOMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/messages/index/[idThread]/[token].vue?macro=true";
import { default as _91idThread_93sgUILcIJ9KMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/messages/index/[idThread].vue?macro=true";
import { default as indexxE7sLpF617Meta } from "/codebuild/output/src3294679881/src/nuxt/pages/messages/index.vue?macro=true";
import { default as my_45listWG33HkWECBMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/my-list.vue?macro=true";
import { default as privacyZwmMzwXrc6Meta } from "/codebuild/output/src3294679881/src/nuxt/pages/privacy.vue?macro=true";
import { default as signature_45productsT3NoS72KGKMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/signature-products.vue?macro=true";
import { default as signupYovKFdPTo8Meta } from "/codebuild/output/src3294679881/src/nuxt/pages/signup.vue?macro=true";
import { default as termstcckxUC2cfMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/terms.vue?macro=true";
import { default as _91token_93HaOcVVopZoMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue?macro=true";
import { default as _91token_93MU1ZX4M4qlMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/unsubscribe/[email]/[token].vue?macro=true";
import { default as _91lessonSlug_93aoahiRPrPVMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/videos/[lessonSlug].vue?macro=true";
import { default as index6894z7qu0mMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/videos/index.vue?macro=true";
import { default as welcomeyMk5vd6pigMeta } from "/codebuild/output/src3294679881/src/nuxt/pages/welcome.vue?macro=true";
export default [
  {
    name: "about-andy",
    path: "/about-andy",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/about-andy.vue")
  },
  {
    name: "andy-guitar-app",
    path: "/andy-guitar-app",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/andy-guitar-app.vue")
  },
  {
    name: "brand-guidelines",
    path: "/brand-guidelines",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/brand-guidelines.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/cookies.vue")
  },
  {
    name: "courses-courseSlug",
    path: "/courses/:courseSlug()",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/courses/[courseSlug].vue")
  },
  {
    name: "courses",
    path: "/courses",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/courses/index.vue")
  },
  {
    name: "donations",
    path: "/donations",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/donations.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/events.vue")
  },
  {
    name: "features",
    path: "/features",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/features.vue")
  },
  {
    name: "free-christmas-mini-songbook",
    path: "/free-christmas-mini-songbook",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/free-christmas-mini-songbook.vue")
  },
  {
    name: "free-resources",
    path: "/free-resources",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/free-resources.vue")
  },
  {
    name: "helpdesk-categorySlug",
    path: "/helpdesk/:categorySlug()",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/helpdesk/[categorySlug].vue")
  },
  {
    name: "helpdesk",
    path: "/helpdesk",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/helpdesk/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/index.vue")
  },
  {
    name: "live-streamSlug",
    path: "/live/:streamSlug()",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/live/[streamSlug].vue")
  },
  {
    name: "live",
    path: "/live",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/live/index.vue")
  },
  {
    name: "login-code",
    path: "/login-code",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/login-code/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/login/index.vue"),
    children: [
  {
    name: "login-index-passcode",
    path: ":passcode()",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/login/index/[passcode].vue")
  }
]
  },
  {
    name: "me-edit",
    path: "/me/edit",
    meta: editJKPHKuCfCCMeta || {},
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/me/edit.vue")
  },
  {
    name: "me",
    path: "/me",
    meta: index93NXjJjirnMeta || {},
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/me/index.vue")
  },
  {
    name: "me-notifications",
    path: "/me/notifications",
    meta: notificationsnl87s8Vgt6Meta || {},
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/me/notifications.vue")
  },
  {
    name: "me-subscriptions-idSubscription-cancel",
    path: "/me/subscriptions/:idSubscription()/cancel",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/me/subscriptions/[idSubscription]/cancel.vue")
  },
  {
    name: "me-subscriptions-idSubscription",
    path: "/me/subscriptions/:idSubscription()",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/me/subscriptions/[idSubscription]/index.vue")
  },
  {
    name: "membership",
    path: "/membership",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/membership.vue")
  },
  {
    name: "messages",
    path: "/messages",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/messages/index.vue"),
    children: [
  {
    name: "messages-index-idThread",
    path: ":idThread()",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/messages/index/[idThread].vue"),
    children: [
  {
    name: "messages-index-idThread-token",
    path: ":token()",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/messages/index/[idThread]/[token].vue")
  }
]
  }
]
  },
  {
    name: "my-list",
    path: "/my-list",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/my-list.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/privacy.vue")
  },
  {
    name: "signature-products",
    path: "/signature-products",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/signature-products.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/signup.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/terms.vue")
  },
  {
    name: "unsubscribe-mailers-email-token",
    path: "/unsubscribe-mailers/:email()/:token()",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue")
  },
  {
    name: "unsubscribe-email-token",
    path: "/unsubscribe/:email()/:token()",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/unsubscribe/[email]/[token].vue")
  },
  {
    name: "videos-lessonSlug",
    path: "/videos/:lessonSlug()",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/videos/[lessonSlug].vue")
  },
  {
    name: "videos",
    path: "/videos",
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/videos/index.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomeyMk5vd6pigMeta || {},
    component: () => import("/codebuild/output/src3294679881/src/nuxt/pages/welcome.vue")
  }
]